import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined, FolderOpenOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Notiflix from "notiflix";

import {
  DatePicker,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Col,
  Form,
  Table,
  Tooltip,
  Divider,
  Button,
  Modal,
  Descriptions,
  Spin,
  Statistic
} from "antd";

//OTHER IMPORTS
import dayjs from 'dayjs';
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';
import styles from "../../../../../../assets/styles/styles";


const { Text } = Typography
const dateFormat = "YYYY-MM-DD";

const ViewGuarantors = (props) => {

  const { userData, pageTitleParam } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);
  const [guarantorDetails, setGuarantorDetails] = useState([]);
  const [guarantorsList, setGuarantorsList] = useState([]);
  const [guarantorsTemplate, setGuarantorsTemplate] = useState([]);

  useEffect(() => {
    getTemplate()
  }, []);


  function getTemplate() {

    const params = {
      associations: "guarantors"
    }
    const url = `${apiConfig.Loans}/${state.id}`

    let body = {
      session,
      params
    };

    setIsLoading(true)
    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false)
        const objList = res;
        setGuarantorsTemplate(objList)

        setGuarantorDetails(objList)
        let tempGuarantorsArray = []

        const activeGuarantors = objList?.guarantors.filter((item) => item.status === true)
        activeGuarantors.forEach((element) => {
          tempGuarantorsArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.firstname ? `${element?.firstname}  ${element?.lastname}` : "-",
            relationship: element?.clientRelationshipType ? element?.clientRelationshipType?.name : "-",
            guarantorType: element?.guarantorType ? element?.guarantorType?.value : "-",
            guarantorTypeId: element?.guarantorType ? element?.guarantorType?.id : "-",
            depositAccount: element?.depositAccount ? element?.depositAccount : "-",
            amount: element?.amount ? element?.amount : "-",
            remainingAmount: element?.remainingAmount ? element?.remainingAmount : "-",
            status: element?.status === true ? "Active" : element?.status === false ? "Inactive" : "-",
          });
        });

        setGuarantorsList(tempGuarantorsArray)

        form.setFieldsValue({
          hideDeletedGuarantors: true
        })
      }
    });
  }

  function onCancel() {
    navigate("/detail-group-loan", { state: state });
  }

  const handleDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Loans}/${state.id}/guarantors/${key.id}`;
        let body = {
          session,
          method: "DELETE",
        };
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteGuarantorMsg);

            getTemplate()
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  // function handleHideDeletedGuarantors (objParam) {
  //   switch (objParam) {
  //     case true:
  //       const activeGuarantors = guarantorsTemplate.guarantors.filter((item)=> item.clientRelationshipType.active === true)
  //       setGuarantorsList(activeGuarantors)
  //       case false:
  //         setGuarantorsList(guarantorsList)
  //     default:
  //       break;
  //   }
  // }

  const items = [
    {
      key: "1",
      label: labelConfig.disbursementDate,
      children: guarantorDetails.timeline?.actualDisbursementDate ? BOM.DateTime(guarantorDetails?.timeline?.actualDisbursementDate, "only-date") : "Not Available",
    },
    {
      key: "2",
      label: labelConfig.currency,
      children: guarantorDetails.currency ? guarantorDetails.currency.name : "-",
    },
    {
      key: "3",
      label: labelConfig.loanOfficer,
      children: guarantorDetails.loanOfficerName ? guarantorDetails.loanOfficerName : "Unassigned",
    },
    {
      key: "4",
      label: labelConfig.loanPurpose,
      children: guarantorDetails.loanPurposeName ? guarantorDetails.loanPurposeName : "Not Provided",
    },

    {
      key: "5",
      label: labelConfig.approvedAmount,
      children: guarantorDetails.approvedPrincipal ?
        <Statistic
          value={guarantorDetails.approvedPrincipal}
          precision={2}
          valueStyle={{ fontSize: "16px" }}
        /> : "-",
    },

    {
      key: "6",
      label: labelConfig.disburseAmount,
      children: guarantorDetails.principal ?
        <Statistic
          value={guarantorDetails.principal}
          precision={2}
          valueStyle={{ fontSize: "16px" }}
        /> : "-",
    },

    {
      key: "7",
      label: labelConfig.arrearsBy,
      children: guarantorDetails.summary ? guarantorDetails.summary.totalOverdue : "Not Provided",
    },

    {
      key: "8",
      label: labelConfig.externalID,
      children: guarantorDetails ? guarantorDetails.externalID : "-",
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Relationship",
      dataIndex: "relationship",
    },
    {
      title: "Guarantor Type",
      dataIndex: "guarantorType",
    },
    {
      title: "Deposit Account",
      dataIndex: "depositAccount",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Remaining Amount",
      dataIndex: "remainingAmount",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <ViewGuarantorModal
            guarantorDetails={guarantorDetails}
            objParam={record}
          />
          &nbsp;
          <EditGuarantorModal
            currentCustomerObj={state}
            userData={userData}
            objParam={record}
            session={session}
            disableEdit={disableEdit}
          />
          &nbsp;
          {BOM.HasPermission("DELETE_GUARANTOR") &&
            <Tooltip title={`Delete Guarantor`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>}
        </>
      )
    }
  ];


  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={pageTitleParam ? pageTitleParam : labelConfig.viewGuarantor}
        pageItems={staticConfig.viewGuarantorBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={form}
            layout="vertical"
          >

            <Row >
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Descriptions
                bordered
                column={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                  xl: 2,
                  xxl: 2,
                }}
                style={{ marginTop: 10, marginBottom: 20 }}
                items={items}
              />
            </Row>

            {
              guarantorsList.length > 0 &&
              <>
                <Row>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.hideDeletedGuarantors}
                      name="hideDeletedGuarantors"
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase()
                          )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                          `${labelConfig.option}`,
                          "select"
                        )}
                        options={staticConfig.yesOrNoData}
                        showSearch
                      // onChange={handleHideDeletedGuarantors}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Table columns={columns} dataSource={guarantorsList} />
              </>
            }
            <Row>
              <Divider />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>

  )
}

export default ViewGuarantors

const ViewGuarantorModal = (props) => {
  const { guarantorDetails, objParam } = props;

  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [guarantorObj, setGuarantorObj] = useState(false);


  function findGuarantor() {
    let tempGuarantor = guarantorDetails?.guarantors.find((item) => item.id === objParam.id)
    setGuarantorObj(tempGuarantor)
  }

  const showModal = () => {
    setIsModalOpen(true);
    findGuarantor()
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const items = [
    {
      key: "1",
      label: labelConfig.firstName,
      children: guarantorObj.firstname ? guarantorObj?.firstname : "-",
    },
    {
      key: "2",
      label: labelConfig.lastName,
      children: guarantorObj.lastname ? guarantorObj.lastname : "-",
    },
    {
      key: "3",
      label: labelConfig.relationship,
      children: guarantorObj.clientRelationshipType ? guarantorObj.clientRelationshipType.name : "-",
    },
    {
      key: "4",
      label: labelConfig.guarantorType,
      children: guarantorObj.guarantorType ? guarantorObj.guarantorType.value : "-",
    },

    {
      key: "5",
      label: labelConfig.joinedDate,
      children: guarantorObj.joinedDate ? BOM.DateTime(guarantorObj?.joinedDate, "only-date") : "-",
    },

    {
      key: "6",
      label: labelConfig.office,
      children: guarantorObj.officeName ? guarantorObj.officeName : "-",
    },

    {
      key: "7",
      label: labelConfig.status,
      children: guarantorObj.status === true ? "Active" : "Inactive",
    },

    {
      key: "8",
      label: labelConfig.s,
      children: "",
    },
  ];


  return (
    <>
      <Tooltip title={`Guarantor Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Guarantor Detail"
        open={isModalOpen}
        // okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              style={{ marginTop: 10, marginBottom: 20 }}
              items={items}
            />
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

const EditGuarantorModal = (props) => {
  const { currentCustomerObj, objParam, session, disableEdit } = props;

  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [relationshipOptions, setRelationshipOptions] = useState([]);

  function getTemplate() {
    const params = {
      template: true,
    };
    const url = `${apiConfig.Loans}/${currentCustomerObj.id}/guarantors/${objParam.id}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;

        const tempRelationshipOptions = []

        objDetail?.allowedClientRelationshipTypes?.forEach((element) =>
          tempRelationshipOptions.push({
            label: element?.name,
            value: element?.id
          })
        )

        setRelationshipOptions(tempRelationshipOptions)

        useForm.setFieldsValue({
          firstname: objDetail?.firstname,
          lastname: objDetail?.lastname,
          clientRelationshipTypeId: objDetail?.clientRelationshipType?.id,
          dob: dayjs(BOM.FormatArrayDate(objDetail?.dob), dateFormat),
          addressLine1: objDetail?.addressLine1,
          addressLine2: objDetail?.addressLine2,
          city: objDetail?.city,
          zip: objDetail?.zip,
          mobileNumber: objDetail?.mobileNumber,
          housePhoneNumber: objDetail?.housePhoneNumber,
        });

        setIsLoading(false);
      }
    });
  }

  const showModal = () => {
    setIsModalOpen(true);
    getTemplate();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {

    const url = `${apiConfig.Loans}/${currentCustomerObj.id}/guarantors/${objParam.id}`;

    formValues.dob = BOM.DateTime(formValues.dob, "only-date");
    formValues.guarantorTypeId = objParam.guarantorTypeId
    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.editGuarantorMsg);

        // close modal
        setIsModalOpen(false);

        //refresh the list
        //  refreshList();

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Tooltip title={`Edit Guarantor`}>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
          disabled={objParam.guarantorType.toLowerCase() === "customer" ? true : false}
        />
      </Tooltip>
      <Modal
        title="Guarantor Detail"
        open={isModalOpen}
        // okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.guarantorInfo}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.relationship}
                name={"clientRelationshipTypeId"}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.relationship,
                    "select"
                  )}
                  options={relationshipOptions}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text >{labelConfig.firstName}</Text>}
                name={"firstname"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Input placeholder='Please enter a value' />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text >{labelConfig.lastName}</Text>}
                name={"lastname"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Input placeholder='Please enter a value' />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateOfBirth}
                name={"dob"}
              >
                <DatePicker
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.dateOfBirth}`,
                    "select"
                  )}
                  style={{
                    width: "100%",
                    height: 35,
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.addressOne}
                name={"addressLine1"}
              >
                <Input placeholder='Please enter a value' />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.addressTwo}
                name={"addressLine2"}
              >
                <Input placeholder='Please enter a value' />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.city}
                name={"city"}
              >
                <Input placeholder='Please enter a value' />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.zip}
                name={"zip"}
              >
                <Input placeholder='Please enter a value' />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.mobileNumber}
                name={"mobileNumber"}
              >
                <Input placeholder='Please enter a value' />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.residence}
                name={"housePhoneNumber"}
              >
                <Input placeholder='Please enter a value' />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};